import axios, { AxiosResponse } from 'axios';

import {
  CodeboxActivityEntryDto,
  CodeboxDto,
  CodeboxHistoryDto,
  CodeboxIntegrationStatusDto,
  ConnectCodeboxDto,
  SyncCodeboxesResultDto,
} from '../dtos/codebox.dto.interface';

class CodeboxService {
  async getIntegrationStatus(): Promise<AxiosResponse<CodeboxIntegrationStatusDto>> {
    return axios.get<CodeboxIntegrationStatusDto>('codeboxes/integration');
  }

  async connect(payload: ConnectCodeboxDto): Promise<AxiosResponse<void>> {
    return axios.post<void>('codeboxes/integration/connect', payload);
  }

  async disconnect(): Promise<AxiosResponse<void>> {
    return axios.delete<void>('codeboxes/integration/disconnect');
  }

  async sync(): Promise<AxiosResponse<SyncCodeboxesResultDto>> {
    return axios.post<SyncCodeboxesResultDto>('codeboxes/sync');
  }

  async getAll(): Promise<AxiosResponse<CodeboxDto[]>> {
    return axios.get<CodeboxDto[]>('codeboxes');
  }

  async assign(codeboxId: string, propertyId: string): Promise<AxiosResponse<CodeboxDto>> {
    return axios.patch<CodeboxDto>(`codeboxes/${codeboxId}/assign`, { propertyId });
  }

  async unassign(codeboxId: string): Promise<AxiosResponse<CodeboxDto>> {
    return axios.delete<CodeboxDto>(`codeboxes/${codeboxId}/assign`);
  }

  async getHistory(codeboxId: string): Promise<AxiosResponse<CodeboxHistoryDto>> {
    return axios.get<CodeboxHistoryDto>(`codeboxes/${codeboxId}/history`);
  }

  async getActivity(): Promise<AxiosResponse<CodeboxActivityEntryDto[]>> {
    return axios.get<CodeboxActivityEntryDto[]>('codeboxes/activity');
  }
}

export default new CodeboxService();
